import { render } from "./form.vue?vue&type=template&id=2aad6552&scoped=true"
import script from "./form.vue?vue&type=script&lang=js"
export * from "./form.vue?vue&type=script&lang=js"

import "./form.vue?vue&type=style&index=0&id=2aad6552&lang=scss&scoped=true"
import "./form.vue?vue&type=style&index=1&id=2aad6552&lang=scss"
script.render = render
script.__scopeId = "data-v-2aad6552"

export default script